import { setUniqueUsersCount, setUsersCount } from "../../../store/Store";
import firebase from "firebase";
import moment from "moment";

const getUsersCount = () => {
  try {
    let ref = firebase.database().ref("usersCount");
    ref.on(
      "value",
      (o) => {
        if (o.exists()) {
          const { count } = o.val() || {};
          setUsersCount(count);
        }
      },
      (e) => ref.off()
    );
    let child = moment().format("MM-YYYY");
    ref.child(child).on(
      "value",
      (o) => {
        if (o.exists()) {
          const { count } = o.val() || {};
          setUniqueUsersCount(count);
        }
      },
      (e) => ref.off()
    );
  } catch (e) {
    console.log(e);
  }
};

export default getUsersCount;
